import {
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  TableCaption,
  TableContainer,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import React from "react";
import {Link} from "react-router-dom";

export default function TradeTable(props) {
  const {trades,pageCount,tradeType} = props;
  const textColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Card
      w='100%'
      px='0px'
      overflowY={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='20px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
           {tradeType} Table
        </Text>
      </Flex>

      <TableContainer>
        <Table variant='striped' colorScheme='teal'>
          <TableCaption>{tradeType} Table</TableCaption>
          <Thead>
            <Tr>
              <Th>S/N</Th>
              <Th>Asset</Th>
              <Th isNumeric>Rate</Th>
              <Th isNumeric>Quantity</Th>
              <Th>Payment Status</Th>
            </Tr>
          </Thead>
          <Tbody>
           {
            trades.map((trade, index) => {
            return (
            <Tr key={index}>
              <Td>
                <Link className="text-white"
                  to={{ pathname:'/admin/trades/trade/'+trade._id, state:{id:trade._id}}}> 
                  #{trade._id}
                </Link>
              </Td>
              <Td>{trade.advert.asset.symbol}</Td>
              <Td isNumeric>{ new Intl.NumberFormat('en-US', {style: 'decimal' ,minimumFractionDigits: 2, maximumFractionDigits: 2}).format(trade.unit["$numberDecimal"])} {trade.advert.asset.symbol}</Td>
              <Td isNumeric>{ new Intl.NumberFormat('en-US', {style: 'decimal' ,minimumFractionDigits: 2, maximumFractionDigits: 2}).format(trade.price["$numberDecimal"]) } &nbsp;  {trade.advert.currency.symbol}</Td>
              <Td>{trade.paid===false?"Not Paid":"Paid"}</Td>
            </Tr>
            )
           })}
          </Tbody>
        </Table>
      </TableContainer>
    
    </Card>
  );
}
